import axiosInstance from "../axiosInterceptor";

export const createWhatsappQuery = async (data) => {
  try {
    const response = await axiosInstance.post(`/student/createWhatsapp`,data);
    return response.data;
  } catch (error) {
    throw error?.response?.data || { message: "Something went wrong" };
  }
};
